import client from './client'

export default {
  ChangePassword: authInfo => client.post('/api/change-password', authInfo)
}
